/** Platform-aware modifier-click helpers for additive (multi-)selection. */

export const isMacPlatform = (() => {
  if (typeof navigator === "undefined") {
    return false;
  }

  return /Mac|iPhone|iPad|iPod/i.test(navigator.platform);
})();

/** Label for the additive-select modifier, for hint text (⌘ on Mac, Ctrl elsewhere). */
export const modifierKeyLabel = isMacPlatform ? "⌘" : "Ctrl";

/** True when a click should add to / remove from a selection rather than replace it. */
export function isAdditiveClick(event: { metaKey: boolean; ctrlKey: boolean }) {
  return isMacPlatform ? event.metaKey : event.ctrlKey;
}
